module.exports = __webpack_public_path__ + "img/ic_gallery.15580394.svg";